import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ActiveUsersIcon, AvgPerUsersIcon, TotalUsersIcon, TotalVideosIcon, YesterdayVideosIcon } from './assets';
import { Skeleton } from '../ui/skeleton';
import { agentDataOverviewHooks } from '@/manager';

/** 智能体数据概览-卡片概览 */
export const DataOverview: React.FC = () => {
  const { t } = useTranslation();

  const { loading, userStatsOverviewData } = agentDataOverviewHooks.useUserStatsOverviewData();

  // 统计数据
  const stats = useMemo(() => {
    return [
      {
        id: 'total-users',
        title: t('agent_dashboard.data_overview.overview.total_users'),
        value: userStatsOverviewData.totalUsers || 0,
        rate: userStatsOverviewData.totalUsersGrowthRate || 0,
        icon: <TotalUsersIcon className="size-5 text-[rgba(102,112,133,1)]" />,
      },
      {
        id: 'active-users',
        title: t('agent_dashboard.data_overview.overview.yesterday_users'),
        value: userStatsOverviewData.yesterdayUniqueUsers || 0,
        rate: userStatsOverviewData.yesterdayUniqueGrowthRate || 0,
        icon: <ActiveUsersIcon className="size-5 text-[rgba(16,185,129,1)]" />,
      },
      {
        id: 'total-videos',
        title: t('agent_dashboard.data_overview.overview.total_generated_count'),
        value: userStatsOverviewData.totalGenerationCount || 0,
        rate: userStatsOverviewData.totalGenerationGrowthRate || 0,
        icon: <TotalVideosIcon className="size-5 text-[rgba(117,66,247,1)]" />,
      },
      {
        id: 'yesterday-videos',
        title: t('agent_dashboard.data_overview.overview.yesterday_generated'),
        value: userStatsOverviewData.yesterdayGenerationCount || 0,
        rate: userStatsOverviewData.generationGrowthRate  || 0,
        icon: <YesterdayVideosIcon className="size-5 text-[rgba(249,115,22,1)]" />,
      },
      {
        id: 'avg-per-user',
        title: t('agent_dashboard.data_overview.overview.average_generated'),
        value: userStatsOverviewData.averageGenerationPerUser?.toFixed(2) || 0,
        rate: userStatsOverviewData.averageGenerationPerUserGrowthRate || 0,
        icon: <AvgPerUsersIcon className="size-5 text-[rgba(107,33,168,1)]" />,
      }
    ];
  }, [userStatsOverviewData])

  return (
    <div className='flex gap-5 flex-wrap'>
      {stats.map((stat, index) => (
        <div
          key={index}
          className='w-[20rem] max-w-[22rem] bg-white rounded-lg  border border-[rgba(233,234,235,1)] p-6 py-6 flex space-x-4 shadow-[0px_1px_2px_rgba(10,13,18,0.05)]'
        >
          <div className={`size-10 border border-[rgba(213,215,218,1)] rounded-md flex items-center justify-center shadow-sm flex-shrink-0`}>
            {stat.icon}
          </div>
          <div className='flex-1 space-y-2'>
            <div className='flex items-center text-sm text-[rgba(102,112,133,1)] font-semibold'>
              <span className='min-w-max'>{stat.title}</span>
              {(
                <div className={cn(
                  "flex items-center pl-2",
                  Number(stat.rate) >= 0 && "text-[rgba(16,185,129,1)]",
                  Number(stat.rate) < 0 && "text-[rgba(249,115,22,1)]",
                )}>
                  {Number(stat.rate) >= 0 && <ArrowUpIcon className='size-4 mr-1' />}
                  {Number(stat.rate) < 0 && <ArrowDownIcon className='size-4 mr-1' />}
                  <span>{(Number(stat.rate) * 100).toFixed(2)}%</span>
                </div>
              )}
            </div>
            {loading && <Skeleton className='h-9 w-20 rounded' />}
            {!loading && <div className='text-3xl font-semibold text-[rgba(16,24,40,1)]'>{stat.value}</div>}
          </div>
        </div>
      ))}
    </div>
  )
}